import { render, staticRenderFns } from "./SendMessageTargetMessageGroupModal.vue?vue&type=template&id=2f389242&lang=pug"
import script from "./SendMessageTargetMessageGroupModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetMessageGroupModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTargetMessageGroupModal.vue?vue&type=style&index=0&id=2f389242&prod&lang=scss&scopeed=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports